import { render, staticRenderFns } from "./input-file.vue?vue&type=template&id=b97c5008&scoped=true"
import script from "./input-file.vue?vue&type=script&lang=js"
export * from "./input-file.vue?vue&type=script&lang=js"
import style0 from "./input-file.vue?vue&type=style&index=0&id=b97c5008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97c5008",
  null
  
)

export default component.exports